import Papa from 'papaparse';
import * as xlsx from 'xlsx';

export const parseCSVFile = (file: File): Promise<string[][]> => {
  return new Promise<string[][]>((resolve, reject) => {
    Papa.parse<string[]>(file, {
      skipEmptyLines: true,
      complete(results: Papa.ParseResult<string[]>) {
        resolve(results.data?.length ? results.data : []);
      },
      error(error: Error) {
        reject(error);
      },
    });
  });
};

export const parseExcelFile = async (file: File, raw = true): Promise<Record<string, string>[]> => {
  const fileData = await file.arrayBuffer();
  const readData = xlsx.read(fileData);

  return xlsx.utils.sheet_to_json(readData.Sheets[readData.SheetNames[0]], {
    raw,
  });
};
